














































































































































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax';
import AbpBase from '../../../../lib/abpbase';
import QuickTable from "../../../../components/table/table.vue";
@Component({
	name:'internalAuditsCost',
	components: {
		QuickTable
	}
})
export default class InternalAuditsCost extends AbpBase {
	initData:any = {
		showModal: false,
		formLoading: false,
		expertChanged: false,		// 专家是否有被删除
		organizations: [],			// 部门数据
		personnels: [],
		searchData: {
			businessAreaFirstLevel: '',
			businessAreaSecondLevel: ''
		},
		businessAreas: [],
		searchBusinessAreas: [],
		modalBusinessAreas: [],
		addExpert: {
			municipalExpert: '',
			nonMunicipalExpert: ''
		},
		cacheData: {
			municipalExperts: [],
			nonMunicipalExperts: []
		},
		formData: {
			id: '',
			businessAreaFirstLevel: '',
			businessAreaSecondLevel: '',
			professionalExpertCount: null,
			trialExpertCount: null,
			headmanFee: null,
			memberFee: null,
			municipalExperts: [],
			nonMunicipalExperts: []
		},
		validate: {
			articleName: [
				{ required: true, message: '请填写防护用品名称', trigger: 'blur' }
			],
			businessAreaFirstLevel: [
				{ required: true, type: 'number', message: '请选择项目业务领域', trigger: 'change' }
			],
			businessAreaSecondLevel: [
				{ required: true, type: 'number', message: '请选择专业类型', trigger: 'change' }
			]
		},
		columns: [
			{
				title: '序号',
				type: 'index',
				width: 60
			},
			{
				title: '项目业务领域',
				key: 'businessAreaFirstLevelDesc'
			},
			{
				title: '专业类型',
				key: 'businessAreaSecondLevelDesc'
			},
			{
				title: '院内市级专家',
				key: 'municipalExperts',
				render: (h:any, params:any) => {
					let arr:any = [];
					if(params.row.municipalExperts) {
						arr = params.row.municipalExperts.map((item:any) => {
							return item.expert.name;
						})
					}
					return h('span', arr.join('、'));
				}
			},
			{
				title: '院内非市级专家',
				key: 'nonMunicipalExpertsFormat'
			},
			{
				title: '内审专业专家人数',
				key: 'professionalExpertCount'
			},
			{
				title: '内审经审专家人数',
				key: 'trialExpertCount'
			},
			{
				title: '专家组长费用（元）',
				key: 'headmanFee'
			},
			{
				title: '专家组成员费用（元）',
				key: 'memberFee'
			},
			{
				title: '操作',
				key: 'action',
				width: 128,
				render: (h:any, params:any) => {
					return h('div', [
						h('Button', {
							props: {
								type: 'success',
								size: 'small'
							},
							on: {
								click: () => {
									this.initData.formData.id = params.row.id;
									this.initData.formData.businessAreaFirstLevel = params.row.businessAreaFirstLevel;
									this.initData.formData.businessAreaSecondLevel = params.row.businessAreaSecondLevel;
									this.initData.formData.professionalExpertCount = params.row.professionalExpertCount;
									this.initData.formData.trialExpertCount = params.row.trialExpertCount;
									this.initData.formData.headmanFee = params.row.headmanFee;
									this.initData.formData.memberFee = params.row.memberFee;
									
									if(params.row.municipalExperts) {
										this.initData.formData.municipalExperts = params.row.municipalExperts.map((item:any) => {
											return {id: item.id, label: item.expert.name, value: item.expertId};
										});
									}else{
										this.initData.formData.municipalExperts = [];
									}
									if(params.row.nonMunicipalExperts) {
										this.initData.formData.nonMunicipalExperts = params.row.nonMunicipalExperts.map((item:any) => {
											return {id: item.id, label: item.expert.name, value: item.expertId};
										});
									}else{
										this.initData.formData.nonMunicipalExperts = [];
									}
									
									this.initData.modalBusinessAreas = [];
							    	this.GetSecondBusinessAreas(params.row.businessAreaFirstLevel).then((res:any) => {
							    		this.initData.modalBusinessAreas = res;
							    	})
									this.initData.showModal = true;
								}
							}
						}, '编辑'),
						h('Button', {
							props: {
								type: 'error',
								size: 'small'
							},
							style: {
								marginLeft: '10px'
							},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
						}, '删除')
					])
				}
			}
		]
	}
	// 初始化
    init() {
    	// 获取部门信息
    	this.$store.dispatch('project/GetbearerOrg').then(() => {
    		this.initData.organizations = this.$store.state.project.bearerOrgId;
    	})
    	// 业务领域一级
    	this.$store.dispatch('project/GetBussinessAreaAsync').then(() => {
    		this.initData.businessAreas = this.$store.state.project.bussinessArea;
    	})
    	// 获取所有自审专家
    	Ajax.get('/api/services/app/User/GetInnerExpertByPageAsync', {params: {SkipCount: 1, MaxResultCount: 80}}).then((res:any) => {
    		this.initData.personnels = res.data.result.items.map((item:any) => {
                return { label: item.name, value: item.id }
            });
    	})
    }
    GetData() {
        (this as any).$refs.table.GetData();
    }
    // 搜索栏改变一级业务领域，获取二级业务领域
    handleChangeSearchBusiness(value:any) {
    	this.initData.searchData.businessAreaSecondLevel = '';
    	this.initData.searchBusinessAreas = [];
    	this.GetSecondBusinessAreas(value).then((res:any) => {
    		this.initData.searchBusinessAreas = res;
    	})
    }
    // 弹窗获取二级业务领域
    handleChangeModalBusiness(value:any) {
    	this.initData.formData.businessAreaSecondLevel = '';
    	this.initData.modalBusinessAreas = [];
    	this.GetSecondBusinessAreas(value).then((res:any) => {
    		this.initData.modalBusinessAreas = res;
    		if(res.length == 0) {
    			this.initData.formData.businessAreaSecondLevel = 0;
    		}
    	})
    }
    // 获取二级业务领域数据
    async GetSecondBusinessAreas(value:any) {
    	let results:any = [];
    	let items:any = this.initData.businessAreas.filter((item:any) => {
    		return item.directoryValue == value;
    	})
    	if(items.length == 0) return results;
    	await Ajax.get('/api/services/app/SysBaseData/GetBussinessAreaByParentIdAsync', {params: {Id: items[0].id}}).then((res:any) => {
    		results = res.data.result.items;
    	})
    	return results;
    }
    // 添加专家
    handleAddExpert(type:any) {
    	let id:any = this.initData.addExpert[type];
    	if(!id) return;
    	let items:any = this.initData.personnels.filter((res:any) => {
    		return res.value == id;
    	})
    	let repeats = this.initData.formData[type + 's'].filter((item:any) => {
    		return item.value == id;
    	})
    	if(repeats.length == 0) {
    		this.initData.formData[type + 's'].push(items[0]);
    	}
    	this.initData.addExpert[type] = null;
    	(this as any).$refs[type].clearSingleSelect();
    }
    // 删除专家
    async handleCloseMunicipalExpert(item:any, type:any) {
    	if(item.id) {
    		await Ajax.delete('/api/services/app/ExpertFee/DeleteHospitalExpertAsync', {params: {Id: item.id}}).then(() => {
    			this.initData.formData[type] = this.initData.formData[type].filter((res:any) => {
		    		return res.value != item.value;
		    	})
    			this.initData.expertChanged = true;
    		})
    	}else{
    		this.initData.formData[type] = this.initData.formData[type].filter((res:any) => {
	    		return res.value != item.value;
	    	})
    	}
    }
    // 新增记录
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
          		let datas:any = this.initData.formData;
          		let params:any = {};
          		let cacheData:any = this.initData.cacheData;
          		for(let k in this.initData.formData) {
					params[k] = datas[k];
				}
          		// 过滤已有的
          		params.municipalExperts = params.municipalExperts.filter((item:any) => {
          			return !item.id;
          		})
          		params.nonMunicipalExperts = params.nonMunicipalExperts.filter((item:any) => {
          			return !item.id;
          		})
          		// 
          		params.municipalExperts = params.municipalExperts.map((item:any) => {
          			return item.value;
          		})
          		params.nonMunicipalExperts = params.nonMunicipalExperts.map((item:any) => {
          			return item.value;
          		})
          		
            	this.initData.formLoading = true;
            	if(this.initData.formData.id) {
            		params.id = this.initData.formData.id;
            		await Ajax.put('/api/services/app/ExpertFee/UpdateExpertFeeAsync', params).then((res:any)=>{
		                this.$Message.success('编辑成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
		                this.initData.expertChanged = true;
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}else{
            		await Ajax.post('/api/services/app/ExpertFee/CreateExpertFeeAsync', params).then((res:any)=>{
		                this.$Message.success('提交成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
		                this.initData.expertChanged = true;
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		if(this.initData.expertChanged) {
    			this.GetData();
    		}
    		this.initData.showModal = false;
    		this.initData.expertChanged = false;
    		this.initData.formData.id = '';
    		this.initData.formData.municipalExperts = [];
    		this.initData.formData.nonMunicipalExperts = [];
    		(this as any).$refs.form.resetFields();
    	}
    }
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此内审费管理？',
            onOk: () => {
                Ajax.delete('/api/services/app/ExpertFee/DeleteExpertFeeAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	this.GetData();
	            })
            }
        });
    }
    mounted() {
    	this.init();
    }
}
